export default __webpack_public_path__ + "static/media/KillerPolyester.c8e27b75.jpg";